import { useEffect, useState,forwardRef,useImperativeHandle } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import useAppAccessor from '../../../../hooks/useappAccessor';

const SelectListCategoriesSub = forwardRef(({
  defaultSelectedItem,
  data,
  onSelect,
  onCloseOtherList
}: {
  defaultSelectedItem: any;
  data: any;
  onSelect: Function;
  onCloseOtherList:Function
},ref) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem);
  const [currentSelectedItem, setCurrentSelectedItem] =
    useState(defaultSelectedItem);
    const { getUserData } = useAppAccessor();
    const { language, client } = getUserData();

  const handleListDisplay = () =>
    setShowOptionList((showOptionList) => !showOptionList);

    useImperativeHandle(ref, () => ({

      handleCloseListDisplay(){
        setShowOptionList(false)
      }
    }));

  const handleOnSelect = (item: any) => {
    setCurrentSelectedItem(item);
    onSelect(item);
    setShowOptionList(false);
  };

  useEffect(() => {
    setSelectedItem(currentSelectedItem);
  }, [currentSelectedItem]);

  useEffect(() => {
    setSelectedItem(language['select_sub_categories']);
  },[data]);

  useEffect(()=>{
    if(showOptionList){
      onCloseOtherList()
    }

  },[showOptionList])



  return (
    <div
      className={`w-56 relative ${data ? "" : "pointer-events-none"} items-center`}
    >
      <div
        className={`flex flex-row bg-neutral-600 w-full pl-6 pr-4 py-4 h-16 ${
          showOptionList ? "rounded-t-lg" : "rounded-lg"
        } items-center`}
        onClick={handleListDisplay}
      >
        <span className="flex flex-1 text-gray-300 mr-3">
          {selectedItem?.categoryName ?? language['select_sub_categories']}
        </span>
        {showOptionList ? (
          <AiFillCaretUp fill="#d4d4d8" size={18} />
        ) : (
          <AiFillCaretDown fill="#d4d4d8" size={18} />
        )}
      </div>
      {showOptionList && Array.isArray(data) && (
        <ul
          className="absolute bg-neutral-600 divide-y rounded-b-lg border-t overflow-y-auto w-56 h-96"
        >
          {data?.map((item: any) => {
            return (
              <li
                className={`${
                  selectedItem?.key === item?.categoryId
                    ? "text-gray-300"
                    : "text-gray-300 font-medium"
                } pl-6 p-4`}
                data-name={item?.categoryName}
                key={item?.categoryId}
                onClick={() => handleOnSelect(item)}
              >
                {item?.categoryName}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
)

export default SelectListCategoriesSub;
